import './styles.scss'
import React from 'react'
import ComingSoonModal from 'Components/UIComponent/ComingSoonModal'
import { COFFEE_GAMES } from 'Utils/Constants'

const CoffeeSnake = (props) => {
  const { GameControls, setShowInfo, showInfo } = props

  return (
    <>
      <div className="snake-game-wrapper">
        <GameControls />
        <div className="snake-thumbnail">
          <video controls className="exchange-image" autoPlay loop playsInline>
            <source src={COFFEE_GAMES.video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      <ComingSoonModal showModal={showInfo} setShowModal={setShowInfo} showText={false} customClassName="game-thumbnail-modal" />
    </>
  )
}

export default CoffeeSnake
